<template>
  <section id="home">
    <nav class="navbar navbar-expand-lg navbar-dark px-4 px-lg-5 py-3 py-lg-0 bg-light fixed-top">
      <router-link to="/" class="navbar-brand p-0">
        <img class="img-fluid m-0" src="../assets/img/logo.png" alt="PREFERE PLUS - Cabinet Conseil RH" width="141" height="25" />
      </router-link>
      <button class="navbar-toggler" type="button" @click="toggleNav">
        <span class="fa fa-bars"></span>
      </button>
      <div :class="['collapse', 'navbar-collapse', {'show': isNavOpen}]" id="navbarCollapse">
        <div class="navbar-nav mx-auto py-0">

          <router-link to="/" class="nav-link nav-item" @click="closeNav">
            <i class="fas fa-home me-1"></i> Accueil
          </router-link>

          <!-- Dropdown Nos Services -->
          <div class="nav-item dropdown"
            @mouseenter="toggleDropdown('services', true)"
            @mouseleave="toggleDropdown('services', false)">
            <a class="nav-link dropdown-toggle" href="#" role="button"
              :class="{ active: isActiveDropdown('services') }">
              <i class="fas fa-th-large me-1"></i> Nos Services
            </a>
            <div :class="['dropdown-menu', { show: isDropdownOpen.services }]">
              <router-link to="/services" class="dropdown-item" @click="closeNav">
                <i class="fas fa-cogs me-2"></i>Tous nos services
              </router-link>
              <router-link to="/job-offers" class="dropdown-item" @click="closeNav">
                <i class="fas fa-briefcase me-2"></i>Offres d'emploi
              </router-link>
              <router-link to="/formations" class="dropdown-item" @click="closeNav">
                <i class="fas fa-graduation-cap me-2"></i>Nos formations
              </router-link>
            </div>
          </div>

          <router-link to="/about" class="nav-link nav-item" @click="closeNav">
            <i class="fas fa-info-circle me-1"></i> A propos
          </router-link>

          <router-link to="/contact" class="nav-link nav-item" @click="closeNav">
            <i class="fas fa-envelope me-1"></i> Contact
          </router-link>

        </div>

        <!-- Phone CTA -->
        <a href="tel:+22901401188884" class="btn btn-phone d-none d-xl-flex">
          <i class="fas fa-phone-alt"></i>
          <span>01 40 11 88 84</span>
        </a>

        <div v-if="firstName && lastName" class="btn user-profile py-1 px-2 ms-2">
          <router-link to="/home" class="user-link">
            <div class="user-icon">
              <i class="fa fa-user-circle"></i>
            </div>
            <div class="user-name">
              {{ truncatedName }}
            </div>
          </router-link>
        </div>
        <div v-else class="auth-buttons">
          <router-link to="/register" class="btn btn-register py-1 px-3 ms-2" @click="closeNav">
            <span class="fas fa-user-plus"></span> S'inscrire
          </router-link>
          <router-link to="/login" class="btn btn-login py-1 px-3 ms-2" @click="closeNav">
            <span class="fas fa-sign-in-alt"></span> Connexion
          </router-link>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      isNavOpen: false,
      isDropdownOpen: {
        services: false
      }
    };
  },
  computed: {
    firstName() {
      return localStorage.getItem("firstName") || "";
    },
    lastName() {
      return localStorage.getItem("lastName") || "";
    },
    truncatedName() {
      const fullName = `${this.lastName} ${this.firstName}`;
      return fullName.length > 20 ? fullName.slice(0, 20).trim() + '...' : fullName;
    },
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    closeNav() {
      this.isNavOpen = false;
      this.isDropdownOpen.services = false;
    },
    toggleDropdown(dropdown, status) {
      this.isDropdownOpen[dropdown] = status;
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    },
    isActiveDropdown(dropdown) {
      const routes = {
        services: ['/services', '/job-offers', '/formations']
      };
      return routes[dropdown].some(route => this.$route.path.startsWith(route));
    },
  },
};
</script>

<style scoped>
:root {
  --primary: #2596be;
  --accent: #e95d16;
}

/*** Navbar ***/
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0,0,0,0.06);
  background: #fff !important;
}

.btn {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 8px;
  text-decoration: none;
}

/* Phone CTA */
.btn-phone {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #29b3cd10;
  color: #29b3cd;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #29b3cd30;
  text-decoration: none;
  transition: all 0.3s;
  white-space: nowrap;
}

.btn-phone:hover {
  background: #29b3cd;
  color: white;
  border-color: #29b3cd;
}

.btn-phone i {
  font-size: 12px;
}

/* Auth buttons */
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 0;
}

.btn-register {
  background-color: #e95d16;
  color: white;
  border: 2px solid #e95d16;
  font-size: 13px;
}

.btn-register:hover {
  background-color: #29b3cd;
  color: white;
  border-color: #29b3cd;
}

.btn-login {
  background-color: transparent;
  color: #2596be;
  border: 2px solid #2596be;
  font-size: 13px;
}

.btn-login:hover {
  background-color: #2596be;
  color: white;
}

.btn span {
  margin-right: 4px;
}

/* User profile */
.user-profile {
  background-color: white;
  border-radius: 10px;
  padding: 5px;
  border: 1px solid #2596be30;
}

.user-profile:hover {
  border-color: #2596be;
}

.user-link {
  display: flex;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  transition: .3s;
  align-items: center;
  text-decoration: none;
  color: #2596be;
}

.user-icon {
  margin-right: 6px;
  color: #1d9dd960;
}

.user-icon i {
  font-size: 24px;
}

.user-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Nav links */
.navbar-dark .navbar-nav .nav-link {
  font-family: 'Poppins', sans-serif;
  position: relative;
  margin-left: 5px;
  padding: 10px 10px;
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  transition: color 0.3s;
  white-space: nowrap;
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .nav-link.router-link-exact-active {
  color: #2596be;
}

.navbar-dark .navbar-nav .nav-link::before {
  position: absolute;
  content: "";
  width: 0;
  height: 2px;
  bottom: -1px;
  left: 50%;
  background: #2596be;
  transition: width 0.3s ease, left 0.3s ease;
}

.navbar-dark .navbar-nav .nav-link:hover::before,
.navbar-dark .navbar-nav .nav-link.active::before,
.navbar-dark .navbar-nav .nav-link.router-link-exact-active::before {
  width: 70%;
  left: 15%;
}

.navbar-dark .navbar-toggler {
  color: #2596be !important;
  border-color: #2596be !important;
}

/* Dropdown */
.dropdown-menu {
  border: none;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  border-radius: 12px;
  padding: 0.5rem 0;
  min-width: 220px;
  animation: fadeInDown 0.2s ease;
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

.dropdown-item {
  font-family: 'Poppins', sans-serif;
  padding: 10px 16px;
  color: #4a5568;
  font-size: 14px;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background: #29b3cd10;
  color: #2596be;
  padding-left: 20px;
}

.dropdown-item i {
  color: #29b3cd;
  width: 20px;
}

/* Mobile */
@media (max-width: 991px) {
  .navbar-dark .navbar-nav .nav-link {
    padding: 10px 0;
  }

  .navbar-dark .navbar-nav .nav-link::before {
    display: none;
  }

  .dropdown-menu {
    box-shadow: none;
    border-radius: 0;
    padding-left: 1rem;
    background: #f8f9fa;
  }

  .auth-buttons {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }

  .btn-phone {
    display: flex !important;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 576px) {
  .navbar-dark {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    background: #fff !important;
  }
}
</style>
